import { httpClient } from '@/infra/protocols/http';
import { IEpisodeDTO } from '@/modules/episodes/dtos/episode.dto';
import { IEpisode } from '@/modules/episodes/entities/episode.entity';
import { EpisodeMapper } from '@/modules/episodes/mappers/episode.mapper';

export async function createEpisode(
  params: CreateEpisodeService.Params,
  data: CreateEpisodeService.Payload,
): Promise<CreateEpisodeService.Response> {
  const body = {
    titulo: data.name,
    imagem: data.fileName,
    descricao: data.description,
  };

  const response = await httpClient.post<IEpisodeDTO>(
    `/v1/projetos/${params.projectId}/podcasts/${params.podcastId}/episodios`,
    body,
  );
  return EpisodeMapper.toPresentation(response);
}

export namespace CreateEpisodeService {
  export interface Payload {
    name: string;
    fileName?: string;
    description: string;
  }

  export type Response = IEpisode;

  export interface Params {
    projectId: string;
    podcastId: string;
  }
}
